import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import Browse from "./pages/Browse";
import CatalogPage from "./pages/CatalogPage";
import LiveTV from "./pages/LiveTV";
import LivePlayerPage from "./pages/LivePlayerPage";
import Kids from "./pages/Kids";
import Detail from "./pages/Detail";
import Watch from "./pages/Watch";
import Search from "./pages/Search";
import MyList from "./pages/MyList";
import Subscriptions from "./pages/Subscriptions";
import ProfileSelect from "./pages/ProfileSelect";
import VerifyEmail from "./pages/VerifyEmail";
import ResetPassword from "./pages/ResetPassword";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminMovies from "./pages/admin/AdminMovies";
import AdminSeries from "./pages/admin/AdminSeries";
import AdminChannels from "./pages/admin/AdminChannels";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminEmail from "./pages/admin/AdminEmail";
import AdminSettings from "./pages/admin/AdminSettings";

import About from "./pages/static/About";
import Careers from "./pages/static/Careers";
import Press from "./pages/static/Press";
import HelpCenter from "./pages/static/HelpCenter";
import Contact from "./pages/static/Contact";
import Devices from "./pages/static/Devices";
import Terms from "./pages/static/Terms";
import Privacy from "./pages/static/Privacy";
import Cookies from "./pages/static/Cookies";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors theme="dark" toastOptions={{ style: { background: "#111", border: "1px solid rgba(255,255,255,0.1)" } }} />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />

            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/press" element={<Press />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />

            <Route path="/profiles" element={<ProtectedRoute><ProfileSelect /></ProtectedRoute>} />
            <Route path="/browse" element={<ProtectedRoute><Browse /></ProtectedRoute>} />
            <Route path="/movies" element={<ProtectedRoute><CatalogPage kind="movies" /></ProtectedRoute>} />
            <Route path="/series" element={<ProtectedRoute><CatalogPage kind="series" /></ProtectedRoute>} />
            <Route path="/new" element={<ProtectedRoute><CatalogPage kind="new" /></ProtectedRoute>} />
            <Route path="/live" element={<ProtectedRoute><LiveTV /></ProtectedRoute>} />
            <Route path="/live/:id" element={<ProtectedRoute><LivePlayerPage /></ProtectedRoute>} />
            <Route path="/kids" element={<ProtectedRoute><Kids /></ProtectedRoute>} />
            <Route path="/movie/:id" element={<ProtectedRoute><Detail kind="movie" /></ProtectedRoute>} />
            <Route path="/series/:id" element={<ProtectedRoute><Detail kind="series" /></ProtectedRoute>} />
            <Route path="/watch/:kind/:id" element={<ProtectedRoute><Watch /></ProtectedRoute>} />
            <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
            <Route path="/my-list" element={<ProtectedRoute><MyList /></ProtectedRoute>} />
            <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="movies" element={<AdminMovies />} />
              <Route path="series" element={<AdminSeries />} />
              <Route path="channels" element={<AdminChannels />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="email" element={<AdminEmail />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="categories" element={<AdminCategories />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
